import React, { useCallback } from "react";
import { ScMarkupPanel } from "./styled";
import { Icon } from "../Icon/Icon";
import { ObjectsContainer } from "./components/ObjectsContainer";
import { useRecoilState } from "recoil";
import { markupState, regionState } from "../markupAtoms";

export const MarkupPanel: React.FC = () => {
  const [markup, setMarkup] = useRecoilState(markupState);
  const [region] = useRecoilState(regionState);

  const selectMarkupTool = useCallback(
    (markupTool: string) => (e: React.MouseEvent<HTMLElement>) => {
      if (e.currentTarget !== e.target) return;

      setMarkup((value) => (value === markupTool ? "" : markupTool));

      e.stopPropagation();
    },
    []
  );

  return (
    <ScMarkupPanel>
      <div className="block">
        <span className="header">ИНСТРУМЕНТЫ</span>
        <hr />
        <button
          onClick={selectMarkupTool("line")}
          className={markup === "line" ? "active" : ""}
        >
          <Icon refIcon={"Ruler"} size={17} /> Линейка
        </button>
        <button
          onClick={selectMarkupTool("polygon")}
          className={markup === "polygon" ? "active" : ""}
        >
          <Icon refIcon={"Rectangle"} size={17} /> Отметить область
        </button>
        {region === "spine" && (
          <button
            onClick={selectMarkupTool("segment")}
            className={markup === "segment" ? "active" : ""}
          >
            <Icon refIcon={"Line"} size={17} /> Отрезок
          </button>
        )}
      </div>
      <div className="block objects">
        <span className="header">ОБЪЕКТЫ</span>
        <hr />
        <ObjectsContainer />
      </div>
    </ScMarkupPanel>
  );
};
